import Summary from "../Summary/summary";
import Tools from "../Tools/tools";
import Logs from "../SystemLogs/SystemLogs";
import Snapshot from "../Snapshot/snapshot";
import Advanced from "../Advanced/Advanced";

export const getTabList = (isSuperUser) => {
  const tabList = [
    {
      name: "SUMMARY",
      key: "summary",
      icon: "",
      Component: Summary,
    },

    {
      name: "SNAPSHOT",
      key: "snapshot",
      icon: "",
      Component: Snapshot,
    },
    {
      name: "TOOLS",
      key: "tools",
      icon: "",
      Component: Tools,
    },
    {
      name: "LOGS",
      key: "logs",
      icon: "",
      Component: Logs,
    },
  ];

  if (isSuperUser) {
    tabList.push({
      name: "ADVANCED",
      key: "advanced",
      icon: "",
      Component: Advanced,
    });
  }

  return tabList;
};
